var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopySmallViolet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.50028C5.74441 8.74973 6.03614 8.9479 6.3581 9.08319C6.68005 9.21848 7.02577 9.28817 7.375 9.28817C7.72423 9.28817 8.06995 9.21848 8.3919 9.08319C8.71386 8.9479 9.00559 8.74973 9.25 8.50028L12.25 5.50028C12.7473 5.003 13.0266 4.32854 13.0266 3.62528C13.0266 2.92202 12.7473 2.24756 12.25 1.75028C11.7527 1.253 11.0783 0.973633 10.375 0.973633C9.67174 0.973633 8.99728 1.253 8.5 1.75028L8.125 2.12528",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49986 5.4998C8.25545 5.25035 7.96372 5.05218 7.64176 4.91689C7.3198 4.7816 6.97408 4.71191 6.62486 4.71191C6.27563 4.71191 5.92991 4.7816 5.60795 4.91689C5.28599 5.05218 4.99426 5.25035 4.74986 5.4998L1.74986 8.4998C1.25258 8.99708 0.973206 9.67154 0.973206 10.3748C0.973206 11.0781 1.25258 11.7525 1.74986 12.2498C2.24714 12.7471 2.92159 13.0264 3.62486 13.0264C4.32812 13.0264 5.00257 12.7471 5.49986 12.2498L5.87486 11.8748",
    stroke: "#A93DCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySmallViolet);
export default __webpack_public_path__ + "static/media/copy-small-violet.23c93113a3bce8cf99d540ca56596c4b.svg";
export { ForwardRef as ReactComponent };